<script>
  import { OptionGroup } from 'element-ui'
  export default {
    name:'ElOptionGroup',
    extends:OptionGroup
  }
</script>
